import * as types from "./types";
import { get } from "@zendesk/knowledge-http-client";

const ORGANIZATIONS_URL = "/api/v2/organizations.json";
const AUTOCOMPLETE_URL = "/api/v2/organizations/autocomplete.json";

function fetchInitialOrganizationsRequest() {
  return {
    type: types.FETCH_INITIAL_ORGANIZATIONS_REQUEST,
  };
}

function fetchInitialOrganizationsSuccess(organizations) {
  return {
    type: types.FETCH_INITIAL_ORGANIZATIONS_SUCCESS,
    organizations,
  };
}

function fetchInitialOrganizationsFailure(error) {
  return {
    type: types.FETCH_INITIAL_ORGANIZATIONS_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchInitial() {
  return dispatch => {
    dispatch(fetchInitialOrganizationsRequest());

    return get(ORGANIZATIONS_URL)
      .then(({ organizations }) =>
        dispatch(fetchInitialOrganizationsSuccess(organizations))
      )
      .catch(err => {
        dispatch(fetchInitialOrganizationsFailure(err));
      });
  };
}

function fetchAutocompleteOrganizationsRequest(query) {
  return {
    type: types.FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST,
    query,
  };
}

function fetchAutocompleteOrganizationsSuccess(query, organizations) {
  return {
    type: types.FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS,
    query,
    organizations,
  };
}

function fetchAutocompleteOrganizationsFailure(error, query) {
  return {
    type: types.FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE,
    error: true,
    payload: error,
    query,
  };
}

export function fetchAutocomplete(query) {
  return dispatch => {
    dispatch(fetchAutocompleteOrganizationsRequest(query));

    return get(`${AUTOCOMPLETE_URL}?name=${query}`)
      .then(({ organizations }) =>
        dispatch(fetchAutocompleteOrganizationsSuccess(query, organizations))
      )
      .catch(err => {
        dispatch(fetchAutocompleteOrganizationsFailure(err, query));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/organizations/index.js